import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const SPEED_DURATION = {
  slow:   70,
  normal: 50,
  fast:   35,
};

const AnnouncementBar = () => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAnnouncement() {
      const { data: row } = await supabase
        .from('announcements')
        .select('message, visible, speed, url')
        .limit(1)
        .maybeSingle();
      setData(row);
      setLoading(false);
    }
    fetchAnnouncement();
  }, []);

  if (loading || !data || !data.visible || !data.message?.trim()) return null;

  const isStatic = data.speed === 'static';
  const duration = SPEED_DURATION[data.speed] ?? SPEED_DURATION.normal;
  const message  = data.message.trim();
  const url      = data.url?.trim() || null;

  const barContent = (
    <>
      {isStatic ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', paddingLeft: '24px', paddingRight: '24px' }}>
          <span className="font-boxen" style={{ color: '#FFFFFF', fontSize: '1.25rem', fontWeight: 200, letterSpacing: '0.09em', lineHeight: '1', textTransform: 'uppercase' }}>
            {message}
          </span>
        </div>
      ) : (
        <div style={{ display: 'inline-block', animation: `scroll ${duration * 2}s linear infinite` }}>
          <span className="font-boxen" style={{ color: '#FFFFFF', fontSize: '1.25rem', fontWeight: 200, letterSpacing: '0.09em', lineHeight: '1', textTransform: 'uppercase' }}>
            {[...Array(5)].map((_, i) => (
              <span key={i} style={{ paddingLeft: '80px', paddingRight: '80px', display: 'inline-block' }}>{message}&nbsp;&nbsp;•</span>
            ))}
          </span>
        </div>
      )}
    </>
  );

  const outerStyle = {
    backgroundColor: '#474747',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    height: '8.333vh',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 60,
    cursor: url ? 'pointer' : 'default',
  };

  return url ? (
    <a href={url} target="_blank" rel="noreferrer" style={{ ...outerStyle, textDecoration: 'none' }}>
      {barContent}
    </a>
  ) : (
    <div style={outerStyle}>
      {barContent}
    </div>
  );
};

export default AnnouncementBar;
